import { ApiNoteStatus } from 'api/rtk-api'

export const getNoteStatusColor = (status: ApiNoteStatus) => {
  switch (status) {
    case 'Active':
    case 'Activating': {
      return 'var(--Success)'
    }
    case 'Expired': {
      return 'var(--Error)'
    }
    default: {
      return 'var(--Warn)'
    }
  }
}
